import { render, staticRenderFns } from "./HomeLearnMore.vue?vue&type=template&id=5bb13e56&scoped=true"
import script from "./HomeLearnMore.vue?vue&type=script&lang=js"
export * from "./HomeLearnMore.vue?vue&type=script&lang=js"
import style0 from "./HomeLearnMore.vue?vue&type=style&index=0&id=5bb13e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb13e56",
  null
  
)

export default component.exports